import React, { memo } from 'react';

import Heading from '@atlaskit/heading';

import { AnimatedContainer } from './animated-container';

export const AnimatedHeader = memo(
	({
		children,
		isStreaming = false,
		id,
		level = 'h2'
	}: {
		children: React.ReactNode;
		id?: string;
		isStreaming?: boolean;
		level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	}) => {
		return (
			<AnimatedContainer isStreaming={isStreaming}>
				<Heading size="xsmall" as={level} id={id}>
					{children}
				</Heading>
			</AnimatedContainer>
		);
	},
);

AnimatedHeader.displayName = 'AnimatedHeader';
